<template>
	<van-popup v-model="payInfoShow" :position="isMobileFlag?'bottom':'center'" get-container="body"
		class="bs-popup " :style="{ height: isMobileFlag?'100%':'' }" :close-on-click-overlay="false" >
		<div class="bs-popup-head">
			<div class="bs-popup-tit">{{$t('银行转账信息')}}</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body">
				<div class="deposit-main">
					<div class="flex-col">
						<div class="deposit-panel">
							<div class="deposit-form">
								<div class="deposit-cell" v-if="paymentData">
									<div class="deposit-cell_bd">
										<div class="account-panel" v-for="(item,index) in paymentData" :key="index">
											<div class="account-row">
												<div class="label">{{$t('收款姓名')}}</div>
												<div class="value">{{item.name}}</div>
												<el-link type="info" v-clipboard:copy="item.name"
													v-clipboard:success="onCopy">{{$t('复制')}}</el-link>
											</div>
											<div class="account-row">
												<div class="label">{{$t('收款账号')}}</div>
												<div class="value">{{item.account}}</div>
												<el-link type="info" v-clipboard:copy="item.account"
													v-clipboard:success="onCopy">{{$t('复制')}}</el-link>
											</div>
											<div class="account-row">
												<div class="label">{{$t('收款银行名称')}}</div>
												<div class="value">{{item.bank_name}}</div>
												<el-link type="info" v-clipboard:copy="item.bank_name"
													v-clipboard:success="onCopy">{{$t('复制')}}</el-link>
											</div>
											<div class="account-row">
												<div class="pay-pic"><img :src="item.logo" alt="" /></div>
											</div>
										</div>
									</div>
								</div>
								
								<div class="deposit-tip">
									<span class="iconfont icon-wentidingdan"></span>{{$t('转账后提示')}}
								</div>
								
							</div>
							<div class="deposit-foot">
								<el-button v-if="isOrderPage" type="primary" @click="payInfoShow = false" round >{{$t('确定')}}</el-button>
								<el-button v-else type="primary" @click="goUrl('/my-order')" round >{{$t('确定')}}</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</van-popup>
</template>
<script>
	import helper from '@/common/helper.js';
	import {payment_lists_api,payment_pay_api,payment_withdraw_api ,bank_list_api} from "@/api/user"
	export default {
		props: {
			isOrderPage: {
				type: Boolean,
				default: false
			}
		},
		components: {},
		data() {
			return {
				payInfoShow:false,
				paymentData:[],
			};
		},
		methods:{
			closedModel(){
				this.goUrl('/my-order')
			},
			onCopy: function() {
				this.successTips("Copy success");
			},
			async getPaymentList() {
				await payment_lists_api().then(res => {
					if (res && res.data.code == 1) {
						this.paymentData = res.data.data
					}
				});
			},
		},
		mounted() {
			this.getPaymentList()
		}
	}
</script>
<style>
	.deposit-tip{
		margin-bottom: 20px;
	}
	.pay-pic{
		margin: 10px 0;
		background-color: #ffffff;
		width: 230px;
		margin-left: auto;
		margin-right: auto;
		border-radius: 16px;
		text-align: center;
		border-radius: 2px;
		padding: 15px;
		box-shadow: 0 0 20px rgba(0, 0, 0, .07);
	}
	.pay-pic img{
		width: 200px;
		height: 200px;
	}
</style>
